var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5073_1897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 9.49903C66.519 9.49903 68.1773 9.55317 73.7137 9.80392C78.8312 10.0376 81.6122 10.8924 83.4615 11.6104C85.9119 12.5621 87.6615 13.7019 89.4993 15.5369C91.3372 17.3747 92.4741 19.1243 93.4258 21.5747C94.1438 23.424 94.9986 26.205 95.2323 31.3225C95.4859 36.8589 95.5372 38.5201 95.5372 52.5362C95.5372 66.5524 95.483 68.2136 95.2323 73.7499C94.9986 78.8674 94.1438 81.6484 93.4258 83.4977C92.4741 85.9482 91.3343 87.6977 89.4993 89.5355C87.6615 91.3734 85.9119 92.5103 83.4615 93.462C81.6122 94.18 78.8312 95.0349 73.7137 95.2685C68.1773 95.5221 66.519 95.5734 52.5 95.5734C38.481 95.5734 36.8198 95.5192 31.2863 95.2685C26.1688 95.0349 23.3878 94.18 21.5385 93.462C19.0881 92.5103 17.3385 91.3705 15.5007 89.5355C13.6628 87.6977 12.5259 85.9482 11.5742 83.4977C10.8562 81.6484 10.0014 78.8674 9.76771 73.7499C9.51411 68.2136 9.46282 66.5524 9.46282 52.5362C9.46282 38.5201 9.51696 36.8589 9.76771 31.3225C10.0014 26.205 10.8562 23.424 11.5742 21.5747C12.5259 19.1243 13.6657 17.3747 15.5007 15.5369C17.3357 13.699 19.0881 12.5621 21.5385 11.6104C23.3878 10.8924 26.1688 10.0376 31.2863 9.80392C36.8227 9.55032 38.4839 9.49903 52.5 9.49903ZM52.5 0.0390625C38.2417 0.0390625 36.4551 0.0988997 30.8532 0.355345C25.2655 0.60894 21.4474 1.49795 18.1079 2.79442C14.6544 4.13648 11.7281 5.9316 8.81031 8.84937C5.89254 11.7671 4.09742 14.6963 2.75536 18.1469C1.45889 21.4864 0.569878 25.3017 0.316282 30.8923C0.0598372 36.4913 0 38.2807 0 52.5391C0 66.7974 0.0598372 68.584 0.316282 74.1859C0.569878 79.7735 1.45889 83.5917 2.75536 86.9312C4.09742 90.3847 5.89254 93.311 8.81031 96.2287C11.7281 99.1465 14.6573 100.942 18.1079 102.284C21.4474 103.58 25.2627 104.469 30.8532 104.723C36.4522 104.979 38.2417 105.039 52.5 105.039C66.7583 105.039 68.5449 104.979 74.1468 104.723C79.7345 104.469 83.5526 103.58 86.8921 102.284C90.3456 100.942 93.2719 99.1465 96.1897 96.2287C99.1075 93.311 100.903 90.3818 102.245 86.9312C103.541 83.5917 104.43 79.7764 104.684 74.1859C104.94 68.5868 105 66.7974 105 52.5391C105 38.2807 104.94 36.4941 104.684 30.8923C104.43 25.3046 103.541 21.4864 102.245 18.1469C100.903 14.6935 99.1075 11.7671 96.1897 8.84937C93.2719 5.9316 90.3427 4.13648 86.8921 2.79442C83.5526 1.49795 79.7373 0.60894 74.1468 0.355345C68.5478 0.0988997 66.7583 0.0390625 52.5 0.0390625Z",
    fill: "url(#paint0_linear_5073_1897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 25.5801C37.6119 25.5801 25.5391 37.6501 25.5391 52.541C25.5391 67.4319 37.6091 79.5019 52.5 79.5019C67.3909 79.5019 79.4609 67.4319 79.4609 52.541C79.4609 37.6501 67.3909 25.5801 52.5 25.5801ZM52.5 70.0391C42.8349 70.0391 34.999 62.2033 34.999 52.5382C34.999 42.873 42.8349 35.0372 52.5 35.0372C62.1651 35.0372 70.0009 42.873 70.0009 52.5382C70.0009 62.2033 62.1651 70.0391 52.5 70.0391Z",
    fill: "url(#paint1_linear_5073_1897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5266 30.8148C84.006 30.8148 86.8266 27.9942 86.8266 24.5148C86.8266 21.0354 84.006 18.2148 80.5266 18.2148C77.0472 18.2148 74.2266 21.0354 74.2266 24.5148C74.2266 27.9942 77.0472 30.8148 80.5266 30.8148Z",
    fill: "url(#paint2_linear_5073_1897)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5073_1897",
    x1: 105.382,
    y1: 122.135,
    x2: 14.4606,
    y2: 2.47529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDC765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AF58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F19552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F15041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE3279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B13ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A93ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#943CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7140DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4545EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5073_1897",
    x1: 79.8513,
    y1: 82.7417,
    x2: 33.4889,
    y2: 31.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDC765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AF58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F19552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F15041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE3279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B13ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A93ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#943CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7140DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4545EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5073_1897",
    x1: 87.9036,
    y1: 31.8919,
    x2: 73.1011,
    y2: 17.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDC765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AF58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F19552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F15041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE3279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B13ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A93ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#943CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7140DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4545EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5073_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white",
    transform: "translate(0 0.0390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.d29871e0f0efe9c0d3cfea9bae1034cf.svg";
export { ForwardRef as ReactComponent };